module.exports = __webpack_public_path__ + "img/9ae582904dd0714765e072dce9bd3133.07812649.jpg";